import { render, staticRenderFns } from "./ReviewFormDialog.vue?vue&type=template&id=0df72ace&scoped=true&"
import script from "./ReviewFormDialog.vue?vue&type=script&lang=js&"
export * from "./ReviewFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReviewFormDialog.vue?vue&type=style&index=0&id=0df72ace&prod&lang=scss&scoped=true&"
import style1 from "./ReviewFormDialog.vue?vue&type=style&index=1&id=0df72ace&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df72ace",
  null
  
)

export default component.exports